import { createAction } from '@reduxjs/toolkit'

import { TDashboardFilterOption } from 'types/GlobalDashboardFilter'

// tryGetResourceFilterOptions
export const getAll = createAction('get_all_dashboard_filter_options')
export const getAllSuccess = createAction<TDashboardFilterOption[]>(
  'get_all_dashboard_filter_options_success'
)
export const getAllFailed = createAction(
  'get_all_dashboard_filter_options_failed'
)

// tryGetResourceFilterData
export const getData = createAction<string[]>('get_dashboard_filter_data')
export const getDataSuccess = createAction<
  {
    attributeId: string
    options: string[]
  }[]
>('get_dashboard_filter_data_success')
